export const RIDER_JOURNEY_STAGES = [
  'Preparing route',
  'Travel to pickup',
  'Arrived at pickup',
  'Waiting for store release',
  'Receive parcels',
  'Ready to deliver',
  'Travel to customer',
  'Arrived',
  'Proof / COD outcome',
  'Completed / recovery',
];

export default function RiderJourneyProgress({ activeIndex }) {
  return (
    <ol aria-label="Delivery journey progress" className="flex snap-x gap-2 overflow-x-auto overscroll-x-contain pb-3">
      {RIDER_JOURNEY_STAGES.map((label, index) => (
        <li key={label} aria-current={index === activeIndex ? 'step' : undefined} className={`min-w-fit snap-start rounded-full px-3 py-2 text-xs font-semibold ${index === activeIndex ? 'bg-emerald-600 text-white' : index < activeIndex ? 'bg-emerald-50 text-emerald-800 dark:bg-emerald-500/10 dark:text-emerald-200' : 'bg-stone-100 text-stone-500 dark:bg-white/5 dark:text-stone-400'}`}>
          {index + 1}. {label}
        </li>
      ))}
    </ol>
  );
}
